import React from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "lucide-react";
import { Listbox, ListboxButton, ListboxOptions } from "@headlessui/react";
import "./Dropdown.scss";

const Dropdown = ({ label, options, selected = [], setSelected }) => {
  const toggleSelection = (option) => {
    setSelected((prev = []) =>
      prev.includes(option) ? prev.filter((item) => item !== option) : [...prev, option]
    );
  };

  return (
    <Listbox value={selected || []} onChange={setSelected} multiple className="dropdown-container w-full md:w-auto">
      <div className="relative">
        <ListboxButton className="gap-2 px-4 py-2 rounded-md flex items-center justify-between min-w-44 w-full md:w-auto">
          {label}
          <ChevronDown size={16} />
        </ListboxButton>

        <ListboxOptions className="listbox-options absolute mt-1 gap-2 w-full bg-white shadow-lg rounded-md z-10 p-2">
          {options.map((option, index) => (
            <div
              key={index}
              className="cursor-pointer flex items-center gap-2 px-3 py-2 hover:bg-gray-200 rounded capitalize"
              onClick={() => toggleSelection(option)}
            >
              <input
                type="checkbox"
                checked={selected.includes(option)}
                onChange={(e) => e.stopPropagation()} // Prevents unwanted toggling from parent div click
                className="w-4 h-4"
              />
              {option}
            </div>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
};

Dropdown.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.array,
  setSelected: PropTypes.func.isRequired
};

export default Dropdown;
